import { parse } from 'date-fns/parse';
import { parseISO } from 'date-fns/parseISO';
import { format } from 'date-fns/format';
import { isValid } from 'date-fns/isValid';
import FormatService from './format-service';

export default class DateService {
  public static DATE_FORMAT_DEFAULT: string = 'MM/dd/yyyy';
  public static WEEK_DAYS_TOTAL: number = 7;
  public static ERROR_INVALID_DATE: string = 'Invalid Date';

  public static getCurrentDateTimeStamp(): number {
    return Date.now();
  }

  public static getDateNow(): string {
    return FormatService.formatDateString(new Date());
  }

  public static getDateYearAgo(): string {
    return FormatService.formatDateString(new Date(new Date().setFullYear(new Date().getFullYear() - 1)));
  }

  public static getTimezoneOffset(): number {
    return -(new Date().getTimezoneOffset());
  }

  public static parseDate(dateValue: string, dateFormat?: string): Date {
    return parse(dateValue, dateFormat || this.DATE_FORMAT_DEFAULT, new Date());
  }

  public static parseISODate(dateValue: string): Date {
    return parseISO(dateValue);
  }

  public static formatDate(dateValue: number | Date): string | number | Date | null {
    if (!dateValue) {
      return null;
    }

    return this.checkIsDateValid(dateValue) ? format(dateValue, this.DATE_FORMAT_DEFAULT) : dateValue;
  }

  public static checkIsDateValid(dateValue: number | string | Date): boolean {
    return dateValue && dateValue !== this.ERROR_INVALID_DATE ? isValid(dateValue) : false;
  }

  public static toUtcDate(dateTimeValue: Date): Date {
    return new Date(
      Date.UTC(
        dateTimeValue.getFullYear(),
        dateTimeValue.getMonth(),
        dateTimeValue.getDate(),
        dateTimeValue.getHours(),
        dateTimeValue.getMinutes(),
        dateTimeValue.getSeconds(),
      ),
    );
  }
}
